/* unplugin-vue-components disabled */import { render } from "./ShareFreeWatch.vue?vue&type=template&id=4707dbfe&scoped=true"
import script from "./ShareFreeWatch.vue?vue&type=script&lang=js"
export * from "./ShareFreeWatch.vue?vue&type=script&lang=js"

import "./ShareFreeWatch.vue?vue&type=style&index=0&id=4707dbfe&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Public\\object\\xvideos-frontend\\mysex\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4707dbfe"]])

export default __exports__